import styled from '@emotion/styled'
import { css } from '@emotion/react'

const Container = styled.button`
  --transtion-duration: ${({ theme }) => theme.style.transitionTime[400]};

  & {
    color: ${({ theme }) => theme.colors.gray[0]};
    background-color: ${({ theme }) => theme.colors.primary[400]};
    border: none;
    width: 100%;
    height: var(--size);
    transition: var(--transtion-duration) opacity,
      var(--transtion-duration) color, var(--transtion-duration) border-color,
      var(--transtion-duration) background-color,
      var(--transtion-duration) box-shadow;
    cursor: pointer;
    font-size: var(--fs-400);
    padding: 0;
    border-radius: 4px;
    overflow: visible;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.colors.gray[400]};
    box-shadow: none;
  }

  &:not(:disabled):hover {
    background-color: ${({ theme }) => theme.colors.primary[500]};
    box-shadow: none;
  }

  &:not(:disabled):focus {
    background-color: ${({ theme }) => theme.colors.primary[400]};
    box-shadow: 2px 2px 12px 0 ${({ theme }) => theme.colors.gray[600]};
  }

  &:not(:disabled):active {
    background-color: ${({ theme }) => theme.colors.primary[500]};
    // box-shadow: inset 2px 2px 5px 0 ${({ theme }) =>
      theme.colors.primary[500]};
  }

  &.secondary-color {
    background-color: ${({ theme }) => theme.colors.secondary[900]};
  }

  &.secondary-color:not(:disabled):hover {
    background-color: ${({ theme }) => theme.colors.secondary[1000]};
  }

  &.secondary-color:not(:disabled):focus {
    background-color: ${({ theme }) => theme.colors.secondary[900]};
    box-shadow: 2px 2px 12px 0 ${({ theme }) => theme.colors.gray[600]};
  }

  &.secondary-color:not(:disabled):active {
    background-color: ${({ theme }) => theme.colors.secondary[900]};
    // box-shadow: inset 2px 2px 5px 0
      // ${({ theme }) => theme.colors.secondary[1000]};
  }

  &.secondary-type {
    color: ${({ theme }) => theme.colors.primary[400]};
    border: solid 2px currentColor;
    background-color: transparent;
  }

  &.secondary-type:disabled {
    color: ${({ theme }) => theme.colors.gray[400]};
    border: solid 2px currentColor;
    background-color: transparent;
  }

  &.secondary-type:not(:disabled):hover {
    border: solid 2px ${({ theme }) => theme.colors.primary[500]};
    background-color: transparent;
  }

  &.secondary-type:not(:disabled):focus {
    border: solid 2px currentColor;
    background-color: transparent;
    box-shadow: 2px 2px 5px 0 ${({ theme }) => theme.colors.gray[400]};
  }

  &.secondary-type:not(:disabled):active {
    background-color: transparent;
    // box-shadow: inset 2px 2px 5px 0 ${({ theme }) => theme.colors.gray[400]};
  }

  &.secondary-type.secondary-color {
    color: ${({ theme }) => theme.colors.secondary[900]};
    border: solid 2px currentColor;
  }

  &.secondary-type.secondary-color:not(:disabled):hover {
    color: ${({ theme }) => theme.colors.secondary[1000]};
    border: solid 2px currentColor;
  }

  &.secondary-type.secondary-color:not(:disabled):focus {
    border: solid 2px ${({ theme }) => theme.colors.secondary[900]};
  }

  &.secondary-type.secondary-color:not(:disabled):active {
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '&': {
          '--size': [
            theme.size.height[200],
            theme.size.height[300],
            theme.size.height[400],
          ],
          fontSize: ['var(--fs-50)', 'var(--fs-50)', 'var(--fs-400)'],
        },
      }),
    ).styles}}
`

export default Container
